import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import ActivityType from '@/components/ActivityType'
import Start from './views/Start'
import Form from './views/Form'
import ThankYou from './views/ThankYou'
import Game from './views/Game'

Vue.use(Router);


export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,

    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/sold-out',
            name: 'soldOut',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/SoldOut.vue')
        },
        {
            path: '/alert',
            name: 'alert',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './components/Alert.vue')
        },
        {
            path: '/selection',
            name: 'selection',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/Selection.vue')
        },
        {
            path: '/activityType/:id',
            component: ActivityType,
            props: true,

            children: [
                {
                    path: 'start',
                    component: Start
                },
                {
                    path: 'game',
                    component: Game
                },
                {
                    path: 'form',
                    component: Form
                },
                {
                    path: 'thank-you',
                    component: ThankYou
                }
            ]
        },
    ]
});
